import React, { useContext } from 'react';
import { MobileContext } from '../../../../Context';
import { Popper, PopperManager } from '../../../../Popover';
import { usePopover } from '../../../../Popovers/redux/hooks';
import { PopoverType } from '../../../../Popovers/redux/types';
import AddToGroupPopover from '../../../_partials/AddToGroupPopup';
import AddToGroupButton from '../AddToGroupButton.add_to_group_2';
var AddToGroupButtonWithPopover = function (_a) {
    var deviation = _a.deviation, actionBarType = _a.actionBarType;
    var isMobile = useContext(MobileContext);
    var _b = usePopover(actionBarType === 'primary'
        ? PopoverType.ADD_TO_GROUP_PRIMARY
        : PopoverType.ADD_TO_GROUP_SECONDARY), popover = _b.popover, pushPopover = _b.pushPopover, removePopover = _b.removePopover;
    var togglePopover = function () {
        if (popover.isOpen) {
            removePopover();
        }
        else {
            pushPopover();
        }
    };
    return (React.createElement(PopperManager, { renderReference: function (_a) {
            var ref = _a.ref;
            return (React.createElement("div", { ref: ref },
                React.createElement(AddToGroupButton, { deviation: deviation, isGroupsPanelOpen: popover.isOpen, onClick: togglePopover, withTooltip: !popover.isOpen })));
        } },
        React.createElement(Popper, { isOpen: popover.isOpen, placement: "top", usePortal: true, positionOnly: true, modifiers: {
                offset: {
                    offset: '0, 20',
                },
            }, onClickOutside: isMobile ? undefined : removePopover },
            React.createElement(AddToGroupPopover, { actionbarType: actionBarType, deviation: deviation, onClose: removePopover }))));
};
AddToGroupButtonWithPopover.displayName = 'AddToGroupButtonWithPopover';
export default AddToGroupButtonWithPopover;
//# sourceMappingURL=AddToGroupButtonWithPopover.js.map